import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Td = styled.td`
  padding-top: 7px !important;
  padding-bottom: 7px !important;
`;
